// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090916/js/" + chunkId + "." + {"44":"64f01ef6","225":"303a393e","481":"19e9ea83","486":"1b8f480a","770":"6b44aa18"}[chunkId] + ".0.9146136728880113.chunk.js";
};